import types from '../types'
import Action from '../../types/Action'

const initialState: {audit: any; updateProviderFileAuditItem: any; selectedProviderFileAudit: any} = {
  audit: {
    loading: true,
    data: null,
    error: false,
    success: false
  },
  updateProviderFileAuditItem: {
    loading: true,
    data: null,
    error: false,
    success: false
  },
  selectedProviderFileAudit: null
}

const providerFileAuditReducer = (state = initialState, action: Action) => {
  switch (action.type) {
	  case types.GET_PROVIDER_FILE_AUDITS_REQUESTED: {
      return {
        ...state,
        audit: {
          loading: true,
          error: false,
          success: false,
          data: null
        }
      }
    }
    case types.GET_PROVIDER_FILE_AUDITS_FULFILLED: {
      return {
        ...state,
        audit: {
          ...state.audit,
          loading: false,
          success: true,
          data: action.payload
        }
      }
    }
	  case types.GET_PROVIDER_FILE_AUDITS_REJECTED: {
      return {
        ...state,
        audit: {
          ...state.audit,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_REQUESTED: {
      return {
        ...state,
        updateProviderFileAuditItem: {
          loading: true,
          error: false,
          success: false,
		      data: []
        }
      }
    }
    case types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_FULFILLED: {
      const fileAuditIndex = state.audit.data.length > 0 ? state.audit.data.findIndex((fileAudit) => fileAudit.providerFileAuditId === action.payload.providerFileAuditId) : -1
      const index = state.audit.data[fileAuditIndex].item ? state.audit.data[fileAuditIndex].item.findIndex((auditElem) => auditElem.providerFileAuditItemId === action.payload.providerFileAuditItemId) : -1
      return {
        ...state,
        updateProviderFileAuditItem: {
		      ...state.updateProviderFileAuditItem,
          loading: false,
          success: true,
          data: action.payload
        },
        audit: {
          ...state.audit,
          data: [
            ...state.audit.data.map(stateAudit => {
              if ( stateAudit.providerFileAuditId === action.payload.providerFileAuditId ) {
                return ({
                  ...stateAudit,
                  item: [
                    ...stateAudit.item.slice(0, index),
                    action.payload,
                    ...stateAudit.item.slice(index + 1)
                  ]
                })
              } else {
                return stateAudit
              }
            })
          ]
        },
        selectedProviderFileAudit: {
          ...state.selectedProviderFileAudit,
          item: [
            ...state.selectedProviderFileAudit.item.slice(0, index),
            action.payload,
            ...state.selectedProviderFileAudit.item.slice(index + 1)
          ]
        }
      }
    }
	  case types.UPDATE_PROVIDER_FILE_AUDIT_ITEM_REJECTED: {
      return {
        ...state,
        updateProviderFileAuditItem: {
		      ...state.updateProviderFileAuditItem,
          loading: false,
          error: action.payload
        }
      }
    }
    case types.SET_SELECTED_PROVIDER_FILE_AUDIT:{
      const providerFileAudit = state.audit.data.find(fileAudit => fileAudit.providerFileAuditId === action.payload)
      return{
        ...state,
        selectedProviderFileAudit: providerFileAudit
      }
    }
    default: {
      return state
    }
  }
}

export default providerFileAuditReducer